import Journey from '@/models/Journey'
import { JourneyPointTransformer } from '@/transformers/JourneyPointTransformer'
import { IdlePointTransformer } from '@/transformers/IdlePointTransformer'
import { NoGpsEventTransformer } from '@/transformers/NoGpsEventTransformer'
import CollectionTransformer from '@/transformers/CollectionTransformer'
import { PointTransformer } from '@/transformers/PointTransformer'

export class JourneyTransformer {
    constructor (
        journeyPointTransformer = new JourneyPointTransformer(),
        collectionTransformer = new CollectionTransformer(),
        idlePointTransformer = new IdlePointTransformer(),
        noGpsEventTransformer = new NoGpsEventTransformer(new PointTransformer())
    ) {
        this.journeyPointTransformer = journeyPointTransformer
        this.collectionTransformer = collectionTransformer
        this.idlePointTransformer = idlePointTransformer
        this.noGpsEventTransformer = noGpsEventTransformer
    }

    transform (data) {
        return new Journey(
            data.id,
            data.hardwareId,
            data.organizationId,
            data.fleetId,
            data.vehicleId,
            data.driverId,
            data.driverName,
            this.journeyPointTransformer.transform(data.startPoint),
            this.journeyPointTransformer.transform(data.endPoint),
            data.lengthMeters,
            data.noGps,
            data.journeyType,
            null != data.idlePts ? this.collectionTransformer.transform(this.idlePointTransformer, data.idlePts) : null,
            null != data.noGpsEvents ? this.collectionTransformer.transform(this.noGpsEventTransformer, data.noGpsEvents) : null,
            data.type
        )
    }
}
